import { queryUsers } from "@/api/users";

const state = () => ({
  all: new Map(),
  current: {},
  loading: false,
  hasNextPage: false,
  nextPageToken: "",
});

const getters = {};

const flattenUsers = (users) => {
  if (users.edges) {
    return users.edges.map((edge) => {
      let user = edge.node;
      user.tenants = user.tenants.edges.map((edge) => edge.node);
      return user;
    });
  }
  return [];
};

const actions = {
  async getUsers({ state, commit }, refresh = false) {
    if (refresh) {
      commit("setHasNextPage", false);
      commit("setNextPageToken", null);
      commit("setUsers", new Map());
    }
    commit("setLoading", true);

    let hasNextPage = state.hasNextPage;
    let nextPageToken = state.nextPageToken ? state.nextPageToken : null;
    const result = await queryUsers(nextPageToken, hasNextPage ? 30 : 60);

    hasNextPage = result.hasNextPage;
    nextPageToken = result.nextPageToken;

    let users = [];
    if (state.all && state.all.size > 0) {
      users = Array.from(state.all.values()).concat(flattenUsers(result.users));
    }

    commit("setHasNextPage", hasNextPage);
    commit("setNextPageToken", nextPageToken);
    commit("setUsers", users.length > 0 ? users : flattenUsers(result.users));
    commit("setLoading", false);
  },

  async getAllUsers({ state, commit }, refresh = false) {
    let hasNextPage = state.hasNextPage;
    if (hasNextPage || refresh) {
      commit("setLoading", true);

      let hasNextPage = true;
      let nextPageToken = null;
      let users = [];

      while (hasNextPage) {
        const result = await queryUsers(nextPageToken, 60);
        hasNextPage = result.hasNextPage;
        nextPageToken = result.nextPageToken;
        users = Array.from(state.all.values()).concat(flattenUsers(result.users));
      }

      commit("setUsers", users);
      commit("setLoading", false);
    }
  },
};

const mutations = {
  setLoading(state, loading) {
    state.loading = loading;
  },
  setUsers(state, users) {
    state.all.clear();
    users.forEach((user) => {
      state.all.set(user.id, user);
    });
  },
  setHasNextPage(state, nextPage) {
    state.hasNextPage = nextPage;
  },
  setNextPageToken(state, pageToken) {
    state.nextPageToken = pageToken;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
